export const SKILLS_BULK_TOGGLE_BEGIN = 'syftacp/SKILLS_BULK_TOGGLE_BEGIN'
export const SKILLS_BULK_TOGGLE_FAILED = 'syftacp/SKILLS_BULK_TOGGLE_FAILED'
export const SKILLS_BULK_TOGGLE_SUCCEEDED = 'syftacp/SKILLS_BULK_TOGGLE_SUCCEEDED'

export const SKILLS_FETCH_BEGIN = 'syftacp/SKILLS_FETCH_BEGIN'
export const SKILLS_FETCH_FAILED = 'syftacp/SKILLS_FETCH_FAILED'
export const SKILLS_FETCH_SUCCEEDED = 'syftacp/SKILLS_FETCH_SUCCEEDED'
